import { request } from "../../utils/config"

export const GET_BACKUP = async () => {
  const response = await request({
    url: `Helpers/RunBackup`,
    Headers: {
      Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
    },
  })
  return response.data
}
